import { FilterFn } from '@tanstack/react-table';
import { InvoiceEvidenceView } from '../../../../../../types/entity-types';

export const inAnyNumberRange: FilterFn<InvoiceEvidenceView> = (row, columnId, ranges?: Array<[number, number]>) => {
  if (!Array.isArray(ranges) || ranges.length === 0) {
    return true;
  }

  const value = row.getValue<number>(columnId);

  return ranges.some(([minRaw, maxRaw]) => {
    const isValueEqualOrHigherThanMin = value >= Math.min(minRaw, maxRaw);
    const isValueEqualOrLowerThanMax = value <= Math.max(minRaw, maxRaw);
    const isValueInRange = isValueEqualOrHigherThanMin && isValueEqualOrLowerThanMax;

    return isValueInRange;
  });
};

inAnyNumberRange.autoRemove = (val: unknown) => !val || (Array.isArray(val) && val.length === 0);
